import React, { useState } from "react";
import { QuickMenuContainer } from "./styled";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
// import { useOutletContext } from "react-router";

const QuickMenu = ({ cmpnyNo, theme, homepageInfo }) => {
  const menus = {
    // sm
    15922: [
      {
        icon: "smartStore.png",
        label: "스마트스토어",
        url: "https://smartstore.naver.com/smvan60000",
      },
      { icon: "blog.png", label: "블로그", url: "https://blog.naver.com/sm_payment" },
      { icon: "kakaoChannel.png", label: "카카오채널", url: "https://pf.kakao.com/_ITxgnC" },
    ],
    // 마법주머니
    29787: [
      {
        icon: "naverMap.png",
        url: "https://map.naver.com/p/entry/place/13245702",
        label: "고명한의원",
      },
      { icon: "blog.png", url: "https://blog.naver.com/ssongwonjang", label: "블로그" },
    ],
  };
  const [menuOpen, setMenuOpen] = useState(true);

  const clickMenu = (item) => {
    if (!menuOpen) return;

    let url = item.url;
    if (!/^https?:\/\//i.test(url)) {
      url = `https://${url}`;
    }

    window.open(url, "_blank");
  };

  const shortcuts = menus?.[cmpnyNo] ?? homepageInfo?.shortcuts;
  if (!Array.isArray(shortcuts) || shortcuts.length === 0) return null;

  return (
    <QuickMenuContainer className={`theme-${theme}`}>
      <button onClick={() => setMenuOpen(!menuOpen)} className={menuOpen ? "active" : "inactive"}>
        <AiOutlineArrowLeft />
      </button>
      <ul className={menuOpen ? "active" : "inactive"}>
        {shortcuts.map((item, idx) => (
          <li key={idx} onClick={() => clickMenu(item)}>
            <img src={`/img/shopTheme/quickLinks/${item.icon}`} alt={item.label} />
            <span>{item.label}</span>
          </li>
        ))}
      </ul>
    </QuickMenuContainer>
  );
};

export default QuickMenu;
